import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";

const json = {
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p16_e2.mp3",
    autoPlay: true,
    video: "",
    isTuLuan:true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E2answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 900, paddingTop: "5px" },
    titleQuestion: [
      {
        num: "2",
        title: `
        <div style=''>
        Ghi lại những trao đổi của em với bạn về nội dung câu chuyện mà em đã đọc.
        </div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ vào mỗi dòng những ý kiến trao đổi của em với bạn về nội dung câu chuyện đã đọc theo gợi ý sau:<br>
        <i>Đó là câu chuyện gì? Của tác giả nào? Nội dung câu chuyện nói về điều gì? Nhân vật chính trong câu chuyện là ai? Nhân vật đó có năng khiếu gì nổi bật? Em có tình cảm, cảm xúc như thế nào với nhân vật đó?… </i>
        <div><video src="Audios/bt_fpt_ai/guide/p16_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    questions: [
      {
        title: `
            <div style='text-align: center'>
              
            <textarea id='0' rows='10'></textarea>
         
            </div>
        `,
        answer: [""],
      },
    ],
  },

  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p16_e1.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    isTuLuan:true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E1answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 900, paddingTop: "5px" },
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ chữ vào mỗi dòng theo gợi ý sau: <br>
        Tác giả em yêu thích là ai? Tác giả đó có những tác phẩm nào nổi bật?
        <div><video src="Audios/bt_fpt_ai/guide/p16_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "1",
        title: `
        <div style=''>
        Kể tên một số câu chuyện của tác giả mà em yêu thích.
        </div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='text-align: center'>
              
            <textarea id='0' rows='10'></textarea>
         
            </div>
        `,
        answer: [""],
      },
    ],
  },

  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p16_e3.mp3",
    autoPlay: true,
    isTuLuan:true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page16/Key/E3answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 900, paddingTop: "5px" },
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em làm bài bằng cách gõ chữ vào mỗi dòng theo gợi ý sau:<br>
        <i>Nhân vật mà em định nói đến là ai, trong tác phẩm của tác giả nào? Cảm xúc của em đối với nhân vật đó như thế nào?</i>
        <div><video src="Audios/bt_fpt_ai/guide/p16_e3.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "2",
        title: `
        <div style=''>
        Viết 2-3 câu thể hiện tình cảm, cảm xúc của em về một nhân vật trong câu chuyện của tác giả mà em yêu thích.
        </div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='margin-left: 69px'>
              
            <textarea id='0' rows='10'></textarea>
         
            </div>
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
